export const WEEK_ENG_STR = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const WEEK_KOR_STR = ["일", "월", "화", "수", "목", "금", "토"];

export const WEATHER_LVL = {
    "Sunny": 0, "Cloudy": 1, "Overcast": 2,
    "Snow": 3, "Rain": 4, "Shower": 5, "Rain/Snow": 6
};

export const WEATHER_ICON = [
    "sun.png", "cloudy.png", "overcast.png",
    "snowy.png", "rainy.png", "shower.png", "rainsnow.png"
];

export const DEFAULT_LOCATION = { lat: 37.56663496478531, lng: 126.97849384643465 }; // 서울시청

export const getWeatherByCode = (sky, pty) => {
    let type = "Sunny", icon = "sun.png";
    if (sky === "1") { type = "Sunny"; icon = "sun.png"; }
    else if (sky === "3") { type = "Cloudy"; icon = "cloudy.png"; }
    else if (sky === "4") { type = "Overcast"; icon = "overcast.png"; }
    if (pty === "1") { type = "Rain"; icon = "rainy.png"; }
    else if (pty === "2") { type = "Rain/Snow"; icon = "rainsnow.png"; }
    else if (pty === "3") { type = "Snow"; icon = "snowy.png"; }
    else if (pty === "4") { type = "Shower"; icon = "shower.png"; }
    return { type, icon };
};

export const getWeatherIconByLevel = (level) => {
    return WEATHER_ICON[level] || "none.png";
};
